/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-31 10:24:23                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-11-05 09:25:45                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Styles
  * Breadcrumb: breadcrumb component
*/

/* Imports */
import { HomeIcon } from "@heroicons/react/24/solid";
import { Breadcrumbs } from "@material-tailwind/react";
import { Link } from "react-router-dom";
/***/

/* Styles */
import "./Breadcrumb.scss";
/***/

/*
* Breadcrumb: breadcrumb component
* Used to display the different parent page
* and give a link to return to them
*/
export function Breadcrumb(props: {path: {name: string, path: string}[]}) {
  return (
    <Breadcrumbs className="et-breadcrumb">
      <Link to="/">
        <HomeIcon className="w-[18px]"/>
      </Link>

      {props.path && props.path.length > 0 && props.path.map((path, index) => (
        <Link key={"breadcrumb-"+index+"-"+path.name} to={path.path}>
          {path.name}
        </Link>
      ))}
    </Breadcrumbs>
  );
}
/***/
